// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import {
  Select,
  MenuItem,
  MenuProps,
  SelectChangeEvent,
  FormControl,
  InputLabel,
} from '@mui/material';
import useStyles from './styles';

export type SelectInputValue = {
  value: string;
  display: string;
};

export type SelectInputProps = {
  label: string;
  value: string;
  setValue?: (value: string) => void;
  values: SelectInputValue[];
  onChange?: (event: SelectChangeEvent, child: React.ReactNode) => void;
  disabled?: boolean;
  required?: boolean;
};

export const SelectInput = ({
  label,
  value,
  setValue,
  values,
  onChange = (e) => setValue && setValue(e.target.value),
  disabled = false,
  required = false,
}: SelectInputProps) => {
  const { classes } = useStyles();
  const menuProps: Partial<MenuProps> = {
    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
    transformOrigin: { vertical: 'top', horizontal: 'left' },
    sx: { borderRadius: 0 },
  };
  return (
    <FormControl variant="standard" className={classes.inputField} fullWidth required={required}>
      <InputLabel className={classes.selectLabel}>{label}</InputLabel>
      <Select
        variant="standard"
        value={value}
        name={label}
        onChange={onChange}
        MenuProps={menuProps}
        disabled={disabled}
      >
        {values.map((v) => (
          <MenuItem key={v.value} value={v.value}>
            {v.display}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
